import _export from '../internals/export.js';
import isIntegralNumber$1 from '../internals/is-integral-number.js';

var $ = _export;
var isIntegralNumber = isIntegralNumber$1;
var abs = Math.abs; // `Number.isSafeInteger` method
// https://tc39.es/ecma262/#sec-number.issafeinteger

$({
  target: 'Number',
  stat: true
}, {
  isSafeInteger: function isSafeInteger(number) {
    return isIntegralNumber(number) && abs(number) <= 0x1FFFFFFFFFFFFF;
  }
});
